export enum GROUP_TYPE {
	PEASY_GROUP = 50,
}

export enum GROUP_ROLE {
	MEMBER = 'member',
	FOLLOWER = 'follower',
	ADMIN = 'admin',
	OWNER = 'owner',
}

export enum GROUP_IMAGE_FIELD {
	COVER_IMAGE = 'coverImage',
	LOGO = 'logo',
}

export enum GROUP_SORTING_METHOD {
	NEWEST_CREATED = 'desc(pod.created)',
	OLDEST_CREATED = 'asc(pod.created)',
	NEWEST_ID = 'desc(pod.id)',
	OLDEST_ID = 'asc(pod.id)',
}

export enum GROUP_TABS {
	MANAGE_EVENTS = 'events',
	MANAGE_FOLLOWERS = 'followers',
}

export enum FOLLOWERS_SORTING_METHOD {
	LATEST_ADDED = 'desc(pod_user.created)',
	OLDEST_ADDED = 'asc(pod_user.created)',
	ALPHABETICAL_A2Z = 'asc(user.nickname)',
	ALPHABETICAL_Z2A = 'desc(user.nickname)',
	ROLE_ASC = 'asc(pod_user.type)',
	ROLE_DESC = 'desc(pod_user.type)',
}

export enum GROUP_ROLE_NAME {
	MEMBER = 'Follower',
	FOLLOWER = 'Follower',
	ADMIN = 'Co-organizer',
	OWNER = 'Organizer',
}

export enum GROUP_FILTER {
	ORGANIZING = 'owner',
	CO_ORGANIZING = 'admin',
}